import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-form-field-view',
  templateUrl: './form-field-view.component.html',
  styleUrls: ['./form-field-view.component.scss'],
})
export class FormFieldViewComponent {
  @Input() title: string;
}
